module.exports = __webpack_public_path__ + "static/media/fg_vn.00de5d83.png";